import React from 'react';

import { Button, Container, Link, Typography } from '@material-ui/core';
import { useHistory, Link as RouterLink } from 'react-router-dom';

import { useRedirectResultStyles } from './styles';

export default ({ onHowItWorks }) => {
  const classes = useRedirectResultStyles();
  const history = useHistory();
  return (
    <Container className={classes.container}>
      <Container>
        <Typography variant="h6" className={classes.title}>
          Your package is now ready!
        </Typography>
        <Typography variant="h6" className={classes.title}>
          Do you want to request your first video report?
        </Typography>
      </Container>
      <Container className={classes.container1}>
        <Typography variant="subtitle1" className={classes.subtitle}>
          Our imaging education specialists will give you a video explanation of your imaging study complete with normal comparisons, diagrams, and 3D models to best educate you on
          your study and explain the important findings.{' '}
          <a href="#" className={classes.link} onClick={onHowItWorks}>
            Click here to see how it works
          </a>
        </Typography>
      </Container>
      <Container className={classes.container2}>
        <Button variant="contained" color="primary" onClick={() => history.push('/personalized-video')}>
          Request Report
        </Button>
      </Container>
      <Container className={classes.container3}>
        <Typography className={classes.subtitle2}>
          <Link component={RouterLink} to="/patient-dashboard" className={classes.link}>
            Go to your personal medical record
          </Link>
        </Typography>
      </Container>
    </Container>
  );
};
